import { gsap } from 'gsap'

const TRIGGER_PX = 80
const DURATION = 0.15
const EASE = 'power2.inOut'
const BG_SOLID = '#ffffff'
// White with 0 alpha (not transparent/black) so the tween doesn't pass through gray.
const BG_CLEAR = 'rgba(255, 255, 255, 0)'

let onScroll: (() => void) | null = null

export const destroyHeaderTransparentBg = () => {
  if (onScroll) {
    window.removeEventListener('scroll', onScroll)
    onScroll = null
  }
}

export const initHeaderTransparentBg = () => {
  destroyHeaderTransparentBg()

  const bg = document.querySelector<HTMLElement>(
    '.header-nav[data-transparent] .header-nav-bg > div > div'
  )
  if (!bg) return

  let solid = window.scrollY >= TRIGGER_PX
  gsap.set(bg, { backgroundColor: solid ? BG_SOLID : BG_CLEAR })

  const update = () => {
    const next = window.scrollY >= TRIGGER_PX
    if (next === solid) return
    solid = next
    gsap.killTweensOf(bg)
    gsap.to(bg, {
      backgroundColor: next ? BG_SOLID : BG_CLEAR,
      duration: DURATION,
      ease: EASE,
    })
  }

  onScroll = update
  window.addEventListener('scroll', update, { passive: true })
}
